import script from "./saleoutView.vue?vue&type=script&setup=true&lang=js"
export * from "./saleoutView.vue?vue&type=script&setup=true&lang=js"

import "./saleoutView.vue?vue&type=style&index=0&id=27c52a6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27c52a6e"]])

export default __exports__